<div class="provider-logins">
  <div class="sso-separator" aria-hidden="true"><span>or</span></div>
  <div class="sso-stack">
    <button type="button" appMicrosoftSignin class="btn-sso">
      <i class="fa-brands fa-microsoft" aria-hidden="true"></i>
      Continue with Microsoft
    </button>
    <button type="button" appGoogleSignin class="btn-sso">
      <i class="fa-brands fa-google" aria-hidden="true"></i>
      Continue with Google
    </button>
  </div>
  <div id="OAuthError" class="oauth-error small" role="alert"></div>
</div>
